import Vue from 'vue';
export var ledgerUnsavedNavState = Vue.observable({
    editing: false,
    dialogVisible: false,
    pendingTo: null,
    discardEdits: null
});
export function setLedgerEditing(editing) {
    ledgerUnsavedNavState.editing = editing;
}
export function registerLedgerUnsavedDiscard(discardEdits) {
    ledgerUnsavedNavState.discardEdits = discardEdits;
}
export function unregisterLedgerUnsavedDiscard() {
    ledgerUnsavedNavState.discardEdits = null;
}
export function shouldBlockLedgerProjectSwitch(to, from) {
    if (!ledgerUnsavedNavState.editing) {
        return false;
    }
    var toProjectId = to.params.id;
    var fromProjectId = from.params.id;
    return Boolean(fromProjectId && toProjectId && toProjectId !== fromProjectId);
}
export function openLedgerUnsavedDialog(to) {
    ledgerUnsavedNavState.pendingTo = to;
    ledgerUnsavedNavState.dialogVisible = true;
}
export function cancelLedgerUnsavedDialog() {
    ledgerUnsavedNavState.pendingTo = null;
    ledgerUnsavedNavState.dialogVisible = false;
}
export function consumeLedgerUnsavedPendingRoute() {
    var pending = ledgerUnsavedNavState.pendingTo;
    ledgerUnsavedNavState.pendingTo = null;
    ledgerUnsavedNavState.dialogVisible = false;
    return pending;
}
